import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { BaseControlComponent } from '../base-control.component';

@Component({
  selector: 'boi-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss']
})
export class FileUploadComponent extends BaseControlComponent {
  @Output() public readonly fileUploadChange = new EventEmitter<File>();
  @Input() public browseButtonLabel: string;
  @Input() public acceptFileTypes: string;
  @Input() public allowMultipleUpload: boolean;
  @ViewChild('fileInput') input: ElementRef;

  onFileUploadChange(filesUploaded: FileList): void {
    Array.from(filesUploaded).forEach((file) => {
      this.fileUploadChange.emit(file);
    });
    this.input.nativeElement.value = '';
  }
}
